(function() {
    'use strict';

    function workflowNotesController($scope, $state, milestones, sessionData,
        workflowStateService, milestoneModalService, notifyService) {
        var vm = this;

        vm.sessionEntity = sessionData.Entity;
        vm.workflowData = workflowStateService.get();

        if (!vm.workflowData.Access.Notes) {
            notifyService.notify('You do not have access to this part of the workflow', true);
            $state.go('workflow.navigator', { workflowId: vm.workflowData.Id.split('/')[1] });
        }

        vm.UnderwritingNotes = [];

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        function buildNotes() {
            var underwritingNotesMap = vm.workflowData.UnderwritingNotes.reduce(function(prev, current) {
                if (current.IsDeleted) {
                    return prev;
                }

                var objectFromPath = workflowStateService.getObjectFromPath(vm.workflowData, current.Path);
                if (!objectFromPath || !objectFromPath.Access || !objectFromPath.Access.Notes) {
                    return prev;
                }

                if (!prev[current.Path]) {
                    prev[current.Path] = {
                        notes: [current],
                        cleanPath: workflowStateService.getCleanPath(current.Path)
                };
                } else {
                    prev[current.Path].notes.push(current);
                }

                return prev;
            }, {});

            for (var path in underwritingNotesMap) {
                if (underwritingNotesMap.hasOwnProperty(path)) {
                    underwritingNotesMap[path].notes = underwritingNotesMap[path].notes.sort(function (a, b) {
                        return a.UpdatedDate - b.UpdatedDate;
                    });
                };
            };

            if (!underwritingNotesMap[''] &&
                workflowStateService.getObjectFromPath(vm.workflowData, '').Access.Notes) {
                underwritingNotesMap[''] = { notes: [], cleanPath: 'Project' };
            }

            vm.UnderwritingNotes = [];
            for (var key in underwritingNotesMap) {
                if (underwritingNotesMap.hasOwnProperty(key)) {
                    vm.UnderwritingNotes.push({
                        path: key,
                        cleanPath: underwritingNotesMap[key].cleanPath,
                        notes: underwritingNotesMap[key].notes
                    });
                }
            }
        }

        buildNotes();

        vm.onNoteAdded = function() {

        }

        vm.onNoteRemoved = function() {

        }

        //vm.isAddingInformationPart = false;

        //if (!vm.workflowData.InternalContent.Access.View) {
        //    notifyService.notify('You do not have access to this part of the workflow', true);
        //    $state.go('workflow.navigator', { workflowId: vm.workflowData.Id.split('/')[1] });
        //}

        //vm.removeInformationPart = function (partIndex) {
        //    workflowStateService.removeInformationPartFromInternalContent(partIndex);
        //}

        //vm.activateAddInformationPart = function () {
        //    vm.isAddingInformationPart = !vm.isAddingInformationPart;
        //}

        $scope.$on('workflowUpdated', function () {
            vm.workflowData = workflowStateService.get();
            buildNotes();
        });
    }

    workflowNotesController.$inject = ['$scope', '$state','milestones', 'sessionData',
        'workflowStateService', 'milestoneModalService', 'notifyService'];

    angular.module('ecap.workflow').controller('workflowNotesController', workflowNotesController);
})();
